if (!customElements.get('collapsible-tabs')) {
  customElements.define(
    'collapsible-tabs',
    class CollapsibleTabs extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.detailsElements = this.querySelectorAll('.accordion-details');
        this.colorScheme = this.dataset.colorScheme;

        this.detailsElements.length > 0 &&
          this.detailsElements.forEach((details) => {
            details.open ? this.handleOpen(details) : this.handleClose(details);
            details.addEventListener('toggle', this.onToggle.bind(this));
          });
      }

      onToggle(event) {
        const activeDetails = event.target;
        if (activeDetails.open) {
          this.handleOpen(activeDetails);
        } else {
          this.handleClose(activeDetails);
        }
      }

      handleOpen(details) {
        const parent = details.closest('.accordion-item');
        parent.classList.contains('accordion-card') && parent.classList.add(this.colorScheme);
      }

      handleClose(details) {
        const parent = details.closest('.accordion-item');
        parent.classList.contains('accordion-card') && parent.classList.remove(this.colorScheme);
      }
    }
  );
}

// Handle mobile layout for Product-Collapsible-tabs sections
function handleProductCollapsibleTabsMobileLayout() {
  const sections = document.querySelectorAll('.Product-Collapsible-tabs');
  
  sections.forEach(section => {
    const wrapper = section.querySelector('.section__wrapper');
    const header = section.querySelector('.section__header');
    const headerText = section.querySelector('.section__header--text');
    const imageCol = section.querySelector('.collapsible-tabs__image-col');
    const contentCol = section.querySelector('.collapsible-tabs__content-col');

    if (!wrapper || !header || !headerText || !imageCol || !contentCol) {
      console.log('Some elements not found in section:', section);
      return;
    }

    const isMobile = window.innerWidth <= 767;
    console.log('Is mobile:', isMobile, 'Width:', window.innerWidth);

    if (isMobile) {
      // Mobile layout: image first, header text second, content third
      wrapper.style.display = 'flex';
      wrapper.style.flexDirection = 'column';
      
      // Style the header container (keep it visible but empty)
      header.style.display = 'block';
      header.style.order = '2';
      header.style.width = '100%';
   
      
      // Move header text out of header and into wrapper, positioned after image
      if (headerText.parentNode === header) {
        // Insert header text after the image column
        imageCol.parentNode.insertBefore(headerText, imageCol.nextSibling);
      }
      
      // Style the header text
      headerText.style.order = '2';
      headerText.style.width = '100%';
    
      headerText.style.display = 'block';
      
      // Set order for mobile
      imageCol.style.order = '1';
      contentCol.style.order = '3';
      
      console.log('Applied mobile layout to section');
    } else {
      // Desktop layout: reset to default
      wrapper.style.display = '';
      wrapper.style.flexDirection = '';
      header.style.display = '';
      header.style.order = '';
      header.style.width = '';
      header.style.margin = '';
      headerText.style.order = '';
      headerText.style.width = '';
      headerText.style.margin = '';
      headerText.style.display = '';
      imageCol.style.order = '';
      contentCol.style.order = '';
      
      // Move header text back to header if it's not already there
      if (headerText.parentNode !== header) {
        header.appendChild(headerText);
      }
      
      console.log('Applied desktop layout to section');
    }
  });
}

// Run on page load and window resize
document.addEventListener('DOMContentLoaded', handleProductCollapsibleTabsMobileLayout);
window.addEventListener('resize', handleProductCollapsibleTabsMobileLayout);

